// Company membership roles, stored as strings in localStorage 'rUser'.
export const ROLES = {
    observateur: '200',
    manageur: '205',
    responsable: '210',
    directeur: '215',
    superviseur: '220',
    admin: '225',
};

// Must stay open to every company role: RequireAuth redirects refused pages to /dashboard,
// so restricting it would create a redirect loop.
export const DASHBOARD_ROLES = [ROLES.observateur, ROLES.manageur, ROLES.responsable, ROLES.directeur, ROLES.superviseur, ROLES.admin];
export const PERSONAL_INFORMATIONS_ROLES = [ROLES.observateur, ROLES.manageur, ROLES.responsable, ROLES.directeur, ROLES.superviseur, ROLES.admin];
export const TIMESHEET_ROLES = [ROLES.observateur, ROLES.manageur, ROLES.responsable, ROLES.directeur, ROLES.superviseur, ROLES.admin];
export const MISSIONS_ROLES = [ROLES.observateur, ROLES.responsable, ROLES.directeur, ROLES.superviseur, ROLES.admin];
export const CONTRACTS_ROLES = [ROLES.observateur, ROLES.responsable, ROLES.directeur, ROLES.admin];
export const INVOICES_ROLES = [ROLES.observateur, ROLES.responsable, ROLES.directeur, ROLES.admin];
export const ACTIVITY_ROLES = [ROLES.observateur, ROLES.responsable, ROLES.directeur, ROLES.admin];
export const PROFILE_ROLES = [ROLES.directeur, ROLES.admin];
export const PERIMETERS_ROLES = [ROLES.directeur, ROLES.admin];
export const TEAM_ROLES = [ROLES.admin];
export const MISSION_CREATION_ROLES = [ROLES.responsable, ROLES.directeur, ROLES.superviseur, ROLES.admin];
